import { IsEmail, IsNotEmpty } from 'class-validator';

export class UserLoginDto {
  /**
   * We don't explicitly validate if this is a valid email to minimize available information for the potential attacker.
   */
  @IsNotEmpty()
  email: string;

  @IsNotEmpty()
  password: string;
}
